import {
  PLAYER_AVATAR_VARIANT_COUNT,
  PlayerAvatarVariant,
  normalizeAvatarVariant,
  resolvePlayerAvatarModule,
} from "@/constants/playerAvatars"
import { CardElement } from "@/types/battle"

export default function AvatarVariantPicker({
  element,
  selected,
  onSelect,
  disabled = false,
  saving = false,
}: {
  element: CardElement | null | undefined
  selected: number | null | undefined
  onSelect: (variant: PlayerAvatarVariant) => void
  disabled?: boolean
  saving?: boolean
}) {
  if (!element) return null
  const current = normalizeAvatarVariant(selected)

  return (
    <div className="mb-4 rounded-2xl border border-white/10 bg-white/[0.04] p-3.5">
      <div className="mb-1 flex flex-row items-center justify-between">
        <span className="text-[15px] font-bold text-white">Аватар стихии</span>
        {saving ? (
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-guardians-accent border-t-transparent" />
        ) : null}
      </div>
      <p className="mb-3 text-xs text-white/45">Выберите один из трёх вариантов</p>
      <div className="flex flex-row gap-2.5">
        {Array.from({ length: PLAYER_AVATAR_VARIANT_COUNT }, (_, i) => {
          const variant = (i + 1) as PlayerAvatarVariant
          const isSelected = current === variant
          return (
            <button
              key={variant}
              type="button"
              disabled={disabled || isSelected}
              onClick={() => onSelect(variant)}
              className={`flex flex-1 flex-col items-center rounded-[14px] border-2 px-1.5 py-2.5 ${
                isSelected
                  ? "border-guardians-accent bg-guardians-accent/10"
                  : "border-transparent bg-black/25"
              } ${disabled ? "opacity-55" : ""}`}
            >
              <img
                src={resolvePlayerAvatarModule(element, variant)}
                alt=""
                className="h-14 w-14 rounded-full object-cover bg-white/[0.06]"
              />
              <span
                className={`mt-1.5 text-xs font-semibold ${isSelected ? "text-guardians-accent" : "text-white/50"}`}
              >
                {variant}
              </span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
